import { Liquid } from 'liquidjs'
import supabase from '@/etc/supabase'

const engine = new Liquid()

export const liquify = async (group, vars) => {
  let template = null
  try {
    const { error, data } = await supabase
      .from('templates')
      .select()
      .eq('group', group)
      .eq('active', true)
      // .signle()

    // console.log('ltpl', data, error)
    if (!error && data && data[0] && data[0].template)
      template = data[0].template
  } catch (err) {
    console.error('liquify read template error', err)
    template = null
  }
  if (!template) {
    console.warn('liquify no template', group)
    return ''
  }

  try {
    const compiled = await engine.parseAndRender(template, vars)
    // console.log('liquify compiled', compiled)
    return compiled
  } catch (err) {
    console.error('compile error', err)
  }
  return ''
}

export const Groups = {
  llm4sd: {
    name: 'LLM->SD',
    vars: {
      env: {
        desc: 'Environmental variables',
        fields: {
          time: 'Time',
          location: 'Location',
          camera: 'Camera',
          color: 'Color',
          description: 'Text description'
        }
      },
      frame: {
        desc: 'Picture variables',
        fields: {
          style: 'Style',
          heroes: 'array of {{Heroes}}',
          action: 'Frame action',
          director: 'Picture director',
          mode: 'Additional text'
        }
      },
      hero: {
        desc: 'Scene main and secondary characters',
        fields: {
          group: 'artist/animal/vehicle/....',
          addon: 'main hero description',
          addon2: 'secondary description',
          image: 'head photo of hero'
        }
      }
    }
  }
}
